import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { ServicePageTemplateBg } from "@/components/site/ServicePageTemplateBg";
import { getServiceBg } from "@/content/services";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/bg/media-monitoring/coverage")({
  head: () => ({
    meta: [
      { title: "Покритие на медийния мониторинг в Югоизточна Европа | Perceptica" },
      {
        name: "description",
        content:
          "Разгледайте покритието на Perceptica по държави, езици, медийни канали и източници в Югоизточна Европа. Медиен мониторинг с широко регионално покритие и данни в реално време.",
      },

      { property: "og:title", content: "Покритие на медийния мониторинг в Югоизточна Европа | Perceptica" },
      { property: "og:description", content: "Разгледайте покритието на Perceptica по държави, езици, медийни канали и източници в Югоизточна Европа. Медиен мониторинг с широко регионално покритие и данни в реално време." },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Покритие на медийния мониторинг в Югоизточна Европа | Perceptica" },
      { name: "twitter:description", content: "Разгледайте покритието на Perceptica по държави, езици, медийни канали и източници в Югоизточна Европа. Медиен мониторинг с широко регионално покритие и данни в реално време." },
      { property: "og:url", content: "https://perceptica.com/bg/media-monitoring/coverage" },
      ...ogImageMeta("bg", "/media-monitoring/coverage"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/media-monitoring/coverage", service: { name: "Услуги за медиен мониторинг", description: "Perceptica media monitoring services for Southeast Europe.", serviceType: "Услуги за медиен мониторинг" } }),
  }),
  component: () => <ServicePageTemplateBg service={getServiceBg("coverage")} />,
});
